import React from 'react';

// Common reusable components
import HelpVideo from '../HelpVideo';
import ComponentHelpDetails from '../ComponentHelpDetails';
import SliderWithVideo from '../SliderWithVideo';
import InstructionScrollField from '../InstructionScrollField';

// Components for Weekly Report
import WeeklyReportScrollList from './WeeklyReport/WeeklyReportScrollList';
import WeeklyReportContent from './WeeklyReport/WeeklyReportContent';

const DailyReportPage = () => {
    return(
        <div className="">
            <SliderWithVideo 
                idName="weekly-report"
                title="Weekly Report"
                video={<HelpVideo link="https://www.youtube.com/embed/TIm5aYYD4GE" title="OSS - Daily Reports Tutorial" />}
                stepper={""}
            >
                <ComponentHelpDetails 
                    scrollList={<WeeklyReportScrollList />} 
                >
                    <InstructionScrollField 
                        title="Weekly Report"
                    >
                        <WeeklyReportContent />
                    </InstructionScrollField>
                </ComponentHelpDetails>
            </SliderWithVideo>
        </div>
    );
};

export default DailyReportPage;
